import React from "react";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import {
    FinancialAccount,
    FinancialAccountSourceType,
} from "@common/types/financialAccount";
import { displayAccountBalance } from "@helpers/financialAccount";

interface Props {
    account: FinancialAccount;
}

function getTextWhenNoBalance(account: FinancialAccount): string {
    if (account.sourceType === FinancialAccountSourceType.FILE_IMPORT) {
        return "This account does not have a balance because it was created through a manual CSV import.";
    }

    return "This institution doesn't support daily balances.";
}

export const FinancialAccountBalance: React.FC<Props> = ({ account }) => {
    const noBalanceText =
        account.balance === null ? getTextWhenNoBalance(account) : null;

    return (
        <Tooltip content={noBalanceText}>
            <span>{displayAccountBalance(account)}</span>
        </Tooltip>
    );
};
